/**
 * This file is used to provide a shim for the document object in a web worker.
 * The document object is not available in a web worker, so we need to provide a shim
 * to prevent errors when running the code in a web worker.
 * 
 * See: https://github.com/vitejs/vite/issues/9879#issuecomment-1372112651
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(self.document as any)  = {
    baseURI: location.origin
};